<mat-dialog-content>
  <h1 class="font-semibold text-2xl pb-3">
    Crear Usuario Externo
  </h1>
  <form [formGroup]="form" class="flex flex-col gap-6 p-3 h-full">
    <div class="my-form">
      <label for="customerName" class="text-gray-500">Cliente</label>
      <p-auto-complete id="customerName" [(ngModel)]="selectedCustomer" [ngModelOptions]="{standalone: true}" [forceSelection]="true"
        [suggestions]="filteredCustomers" (completeMethod)="searchCustomer($event)" (onSelect)="handleSelection($event)"
        [minQueryLength]="4" [delay]="300"
        [inputStyle]="{'border': '0', 'outline': 'none', 'background': 'transparent', 'width': '100%', 'cursor': data ? 'not-allowed' : 'text'}"
        [class.bg-gray-200]="data" [class.cursor-not-allowed]="data"
        class="w-full p-2 rounded-2xl border border-gray-400"
        [panelStyleClass]="'lexend-panel w-full p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400'"
        optionLabel="name" [disabled]="data">
      </p-auto-complete>
    </div>
    <div>
      <label for="addressNumber" class="text-gray-500">A. N.</label>
      <input [disabled]="true" id="addressNumber" type="number" formControlName="addressNumber"
        class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
        [ngClass]="{'border-red-500':f['addressNumber'].invalid && (f['addressNumber'].touched || f['addressNumber'].dirty)}" />
      @if (f['addressNumber'].touched && f['addressNumber'].invalid) {
      <p class="text-red-500 text-sm mt-1">
        El Address Number es requerido.
      </p>
      }
    </div>
    <div>
      <label for="name" class="text-gray-500">Nombre de Usuario</label>
      <input id="name" type="text" formControlName="name"
        class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400"
        [ngClass]="{'border-red-500':f['name'].invalid && (f['name'].touched || f['name'].dirty)}" />
      @if (f['name'].touched && f['name'].errors?.['required']) {
      <p class="text-red-500 text-sm mt-1">
        El nombre de usuario es requerido.
      </p>
      }
    </div>
    <div>
      <label for="email" class="text-gray-500">Correo Electrónico</label>
      <input [disabled]="true" id="email" formControlName="email"
        class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400"
        [ngClass]="{'border-red-500':f['email'].invalid && (f['email'].touched || f['email'].dirty)}" />
      @if (f['email'].touched && f['email'].errors?.['required']) {
      <p class="text-red-500 text-sm mt-1">
        El Correo Electrónico es requerido.
      </p>
      } @else if (f['email'].touched && f['email'].errors?.['email']) {
      <p class="text-red-500 text-sm mt-1">
        El Correo Electrónico es inválido.
      </p>
      }
    </div>
    <div>
      <label for="phone" class="text-gray-500">Número de Teléfono</label>
      <input [disabled]="true" id="phone" placeholder="+59398XXXXXXX o 098XXXXXXX" formControlName="phone"
        class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400"
        [ngClass]="{'border-red-500':f['phone'].invalid && (f['phone'].touched || f['phone'].dirty)}" />
      @if (f['phone'].touched && f['phone'].errors?.['required']) {
      <p class="text-red-500 text-sm mt-1">
        El Número de Teléfono es inválido.
      </p>
      } @else if (f['phone'].touched && (f['phone'].errors?.['maxlength'] || f['phone'].errors?.['minlength'])) {
      <p class="text-red-500 text-sm mt-1">
        El Número de Teléfono es inválido.
      </p>
      } @else if (f['phone'].touched && (f['phone'].errors?.['pattern'])) {
      <p class="text-red-500 text-sm mt-1">
        El Número de Teléfono es inválido.
      </p>
      }
    </div>
    <div>
      <label class="text-gray-500 block mb-3">Roles</label>
      <div class="flex flex-col gap-3">
        <label class="flex items-center gap-3 cursor-pointer">
          <input 
            type="radio" 
            name="roleSelection"
            value="COMPRADOR"
            (change)="onRoleSelectionChange('COMPRADOR')"
            [checked]="getRoleSelection() === 'COMPRADOR'"
            class="w-5 h-5 border-gray-400 text-orange-500 focus:ring-orange-500"
          />
          <span class="text-gray-700 text-base">Comprador</span>
        </label>
        <label class="flex items-center gap-3 cursor-pointer">
          <input 
            type="radio" 
            name="roleSelection"
            value="DUEÑO"
            (change)="onRoleSelectionChange('DUEÑO')"
            [checked]="getRoleSelection() === 'DUEÑO'"
            class="w-5 h-5 border-gray-400 text-orange-500 focus:ring-orange-500"
          />
          <span class="text-gray-700 text-base">Dueño del negocio</span>
        </label>
        <label class="flex items-center gap-3 cursor-pointer">
          <input 
            type="radio" 
            name="roleSelection"
            value="AMBOS"
            (change)="onRoleSelectionChange('AMBOS')"
            [checked]="getRoleSelection() === 'AMBOS'"
            class="w-5 h-5 border-gray-400 text-orange-500 focus:ring-orange-500"
          />
          <span class="text-gray-700 text-base">Completo</span>
        </label>
      </div>
      @if (selectedRoles.length === 0 && form.touched) {
      <p class="text-red-500 text-sm mt-1">
        Debe seleccionar al menos un rol.
      </p>
      }
    </div>
    @if ((selectedCustomer || data) && (isRoleSelected('COMPRADOR') || getRoleSelection() === 'AMBOS')) {
    <div>
      <label for="warehouses" class="text-gray-500">Bodegas</label>
      <div class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400"
        [ngClass]="{'border-red-500':f['warehouses'].invalid && (f['warehouses'].touched || f['warehouses'].dirty)}">
        <mat-select 
          id="warehouses"
          formControlName="warehouses" 
          multiple
          (selectionChange)="handleWarehouseSelection($event)"
          [style]="{'border': '0', 'outline': 'none', 'background': 'transparent', 'width': '100%'}"
          panelClass="lexend-dialog"
          class="w-full">
          <mat-option *ngFor="let warehouse of filteredWarehouses" [value]="warehouse">
            {{warehouse.code}} - {{ warehouse.name }}
          </mat-option>
        </mat-select>
      </div>
      @if (f['warehouses'].touched && f['warehouses'].invalid) {
      <p class="text-red-500 text-sm mt-1">
        Al menos una bodega es requerida.
      </p>
      }
    </div>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions class="gap-2 flex flex-row">
  <button class="rounded-3xl flex items-center gap-2 bg-gray-400 text-white py-2 px-4 cursor-pointer hover:bg-gray-600"
    (click)="close(false)">
    <span class="text-base">Cancelar</span>
    <i class="fi-rr-ban text-base flex"></i>
  </button>
  <button
    class="rounded-3xl flex items-center gap-2 bg-orange-500 text-white py-2 px-4 cursor-pointer hover:bg-orange-600 disabled:bg-orange-200 disabled:cursor-not-allowed"
    (click)="save()" [disabled]="form.invalid">
    <span class="text-base">Guardar</span>
    <i class="fi-rr-disk text-base flex"></i>
  </button>
</mat-dialog-actions>